import {
    Directive,
    ElementRef,
    Optional,
    Renderer2,
    Self,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector:
        'input[wdxInputText],select[wdxInputText],textarea[wdxInputText],button[wdxInputText]',
    host: {
        class: 'form-control',

        '[class.is-invalid]':
            "control?.touched && control?.status === 'INVALID'",
    },
    standalone: false,
})
export class WdxInputTextDirective {
    constructor(
        @Optional() @Self() public control: NgControl,
        private elementRef: ElementRef,
        private renderer: Renderer2,
    ) {
        this.renderer.setAttribute(
            this.elementRef.nativeElement,
            'autocomplete',
            'off',
        );
    }
}
